export default __webpack_public_path__ + "static/media/qufus_logo_dark.259d9f8c.png";